import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { createApi } from "@reduxjs/toolkit/query/react";
import { sec } from "../../../security";
import { AttorneyConnection } from "./model/attorneyConnection";

const apiServerUrl = process.env.REACT_APP_HAISTACK_API_URL;

export const attorneyConnectionApi = createApi({
  reducerPath: "attorneyConnectionApi",
  baseQuery: fetchBaseQuery({
    baseUrl: apiServerUrl,
    prepareHeaders: async (headers) => {
      const token = await sec.getAccessTokenSilently()();
      if (token) headers.set("authorization", `Bearer ${token}`);
      return headers;
    }
  }),
  endpoints: (builder) => ({
    // result type = EmployeesView, arg type = string
    getAttorneyConnections: builder.query<
      AttorneyConnection,
      { attorneyId: string; publicToken: string }
    >({
      query: ({ attorneyId, publicToken }) => {
        if (publicToken) {
          return `/api/v2/attorney_connections?attorney_id=${attorneyId}&shared_target_list=${publicToken}`;
        }
        return `/api/v2/attorney_connections?attorney_id=${attorneyId}`;
      },
      // server returns AttorneyResponse; map it to AttorneysView
      transformResponse: (response: AttorneyConnection): AttorneyConnection =>
        response
    })
  })
});

export const { useGetAttorneyConnectionsQuery } = attorneyConnectionApi;
